import React, { useEffect, useState } from "react";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableRow,
  Paper,
  TextField,
  IconButton,
  Button,
  Box,
  Select,
  MenuItem,
  Tooltip,
  FormControl,
  InputLabel,
  Typography,
} from "@mui/material";
import Dashboard from "../../dashboard/Dashboard";

import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";
import { useNavigate, useParams } from "react-router-dom";
import { ProcessTable } from "./ProcessTable";

import { useDispatch, useSelector } from "react-redux";
import {
  creatTool,
  editJob,
  getAllTools,
  getSingleJob,
} from "../../../actions/job";
import { ArrowBack } from "../../../common/BackArrow";
import { formattedEditDate } from "../../../common/formattedDate";
import Loader from "../../loader/Loader";
import MyModal from "../../../utils/Modal";
import { formatDecimalMinutesToMinutesSeconds } from "../../../utils/timeHelper";
import CustomToolModal from "../../../common/CustomToolModal";
const containsText = (text, searchText) =>
  text.toLowerCase().indexOf(searchText.toLowerCase()) > -1;

function UpdateJob() {
  const dispatch = useDispatch();
  const { id } = useParams();
  const { loading } = useSelector((state) => state.job);
  const { tools: allTools = [] } = useSelector((state) => state.tool);
  const navigate = useNavigate();
  const requiredFieldsByProcess = {
    Milling: [
      "process",
      "description",
      "machineName",
      "toolingUsed",
      "toolingSize",
      "width",
      "length",
      "feed",
      "dc",
      "mr",
      "requiredDimension",
      "estimatedCT",
    ],
    Boring: [
      "process",
      "description",
      "machineName",
      "toolingUsed",
      "toolingSize",
      "width", // Added Width
      "length", // Added Length
      "dc",
      "mr",
      "requiredDimension",
      "estimatedCT",
    ],
    Drilling: [
      "process",
      "description",
      "machineName",
      "toolingUsed",
      "dia",
      "rpm",
      "feed",
      "length",
      "noh",
      "requiredDimension",
      "estimatedCT",
    ],
    Tapping: [
      "process",
      "description",
      "machineName",
      "toolingUsed",
      "dia",
      "rpm",
      "feed",
      "length",
      "noh",
      "requiredDimension",
      "estimatedCT",
    ],
  };
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [modalMessage, setModalMessage] = useState("");

  // Add tool modal states
  const [toolModalOpen, setToolModalOpen] = useState(false);
  const [customToolName, setCustomToolName] = useState("");
  const [currentToolContext, setCurrentToolContext] = useState({
    containerIndex: null,
    rowIndex: null,
    processType: null,
  });

  const [containers, setContainers] = useState([
    {
      processName: "",
      setting: null, // Add any initial values you need
      processTableData: [],
    },
  ]);
  const [formData, setFormData] = useState({
    soWo: "",
    prodOrderNo: "",
    woDate: new Date().toISOString().split("T")[0],
    jobName: "",
    poNo: "",
    estimatedtotalCT: "",
    actualtotalCT: "",
    dragNo: "",
    processTable: [...containers],
  });
  const [errors, setErrors] = useState({
    soWo: false,
    prodOrderNo: false,
    jobName: false,
    poNo: false,
    estimatedtotalCT: false,

    dragNo: false,
  });

  const [processTableErrors, setProcessTableErrors] = useState(
    formData?.processTable?.map(() => ({
      process: false,
      description: false,
      machineName: false,
      toolingUsed: false,
      dc: false,
      length: false,
      width: false,
      feed: false,
      estimatedCT: false,
    })) || []
  );

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await dispatch(getSingleJob(id));
        const loadedData = response.payload || {};

        setFormData({
          soWo: loadedData.soWo || "",
          prodOrderNo: loadedData.prodOrderNo || "",
          woDate: loadedData.woDate || new Date().toISOString().split("T")[0],
          jobName: loadedData.jobName || "",
          poNo: loadedData.poNo || "",
          estimatedtotalCT: loadedData.estimatedtotalCT || "",
          actualtotalCT: loadedData.actualtotalCT || "",
          dragNo: loadedData.dragNo || "",
          processTable: loadedData.processTable || [...containers],
        });

        setContainers(loadedData.processTable || []);
      } catch (error) {
        console.error("Error fetching job data:", error);
      }
    };

    fetchData();
  }, [dispatch, id]);

  useEffect(() => {
    // Whenever 'containers' changes, update 'formData' to include the latest 'containers'
    setFormData((prevFormData) => ({
      ...prevFormData,
      processTable: containers,
    }));
  }, [containers]);

  useEffect(() => {
    const totalEstimatedCT = calculateTotalEstimatedCT(containers);

    setFormData((prevData) => ({
      ...prevData,
      processTable: containers,
      estimatedtotalCT: totalEstimatedCT,
    }));
    // Clear the estimatedtotalCT error when it's calculated
    if (errors.estimatedtotalCT && totalEstimatedCT > 0) {
      setErrors((prevErrors) => ({
        ...prevErrors,
        estimatedtotalCT: false,
      }));
    }
  }, [containers]);

  // Add a function to format the total estimated CT for display
  const formatTotalEstimatedCT = (decimalMinutes) => {
    return formatDecimalMinutesToMinutesSeconds(decimalMinutes);
  };

  const handleOpenModal = (message) => {
    setModalMessage(message);
    setIsModalOpen(true);
  };

  const handleCloseModal = () => {
    setIsModalOpen(false);
    setModalMessage("");
  };

  // Fetch all tools on component mount
  useEffect(() => {
    dispatch(getAllTools());
  }, [dispatch]);

  // Function to get filtered tools by parentType (same as CreateJob)
  const getFilteredTools = (parentType) => {
    if (!parentType || !allTools || allTools.length === 0) return [];
    return allTools.filter((tool) => tool.parentType === parentType);
  };

  // ToolSelect component (same as CreateJob)
  const ToolSelect = ({
    containerIndex,
    rowIndex,
    processName,
    value,
    onChange,
  }) => {
    const filteredTools = getFilteredTools(processName);

    return (
      <FormControl fullWidth size="small">
        <InputLabel>Tooling Used</InputLabel>
        <Select
          value={value || ""}
          label="Tooling Used"
          onChange={(e) =>
            onChange(e, rowIndex, "toolingUsed", containerIndex, processName)
          }
          error={processTableErrors[containerIndex]?.[rowIndex]?.toolingUsed}
        >
          <MenuItem value="">
            <em>Select Tool</em>
          </MenuItem>
          {filteredTools.map((tool) => (
            <MenuItem key={tool._id} value={tool.toolingName}>
              {tool.toolingName}
            </MenuItem>
          ))}
          {/* Add custom tool option */}
          <MenuItem value="custom">
            <em>+ Add Custom Tool</em>
          </MenuItem>
        </Select>
      </FormControl>
    );
  };

  // Tool modal functions (same as CreateJob)
  const handleOpenToolModal = (containerIndex, rowIndex, processType) => {
    setCurrentToolContext({
      containerIndex,
      rowIndex,
      processType,
    });
    setCustomToolName("");
    setToolModalOpen(true);
  };

  const handleCloseToolModal = () => {
    setToolModalOpen(false);
    setCustomToolName("");
    setCurrentToolContext({
      containerIndex: null,
      rowIndex: null,
      processType: null,
    });
  };

  const handleSaveCustomTool = async (customToolName) => {
    if (!customToolName.trim()) {
      alert("Please enter a tool name");
      return;
    }

    const { containerIndex, rowIndex, processType } = currentToolContext;

    try {
      // Save custom tool to backend
      const payload = {
        toolingName: customToolName,
        parentType: processType,
      };
      const createdTool = await dispatch(creatTool(payload));

      if (createdTool.type === "tools/createTools/fulfilled") {
        // Update the toolingUsed field in the current row
        handleTextFieldChange(
          { target: { value: customToolName } },
          rowIndex,
          "toolingUsed",
          containerIndex,
          processType
        );

        handleCloseToolModal();
      } else {
        alert("Failed to save custom tool");
      }
    } catch (error) {
      console.error("Error saving custom tool:", error);
      alert("Error saving custom tool");
    }
  };

  const handleValidation = (event, rowIndex) => {
    const enteredValue = event.target.value;
    console.log("validation", enteredValue);
    if (!/^[0-9]*$/.test(enteredValue)) {
      // If the entered value is not a number, update the error state

      setProcessTableErrors((prevErrors) => ({
        ...prevErrors,
        [rowIndex]: {
          ...prevErrors[rowIndex],
          toolingSize: "Only numbers are allowed",
        },
      }));
    } else {
      // If the entered value is a number, clear the error state
      setProcessTableErrors((prevErrors) => ({
        ...prevErrors,
        [rowIndex]: {
          ...prevErrors[rowIndex],
          toolingSize: "",
        },
      }));
    }
  };

  const handleSubmit = async (e, formDataToSubmit) => {
    if (e && e.preventDefault) {
      e.preventDefault();
    }

    // Merge current formData with containers data
    const dataToSubmit = formDataToSubmit || formData;

    // Validate required fields (similar to create job)
    const requiredFields = [
      "soWo",
      "jobName",
      "poNo",
      "estimatedtotalCT",
      "dragNo",
    ];
    const ProcessrequiredFields = [
      "process",
      "description",
      "machineName",
      "toolingUsed",
    ];
    let newErrors = {};

    requiredFields.forEach((field) => {
      const fieldValue = dataToSubmit[field];
      if (!fieldValue || fieldValue.toString().trim() === "") {
        console.log(`Validation failed for ${field}:`, fieldValue);
        newErrors[field] = true;
      }
    });

    if (Object.keys(newErrors).length > 0) {
      setErrors(newErrors);
      return;
    }

    const newProcessTableErrors = containers?.map((container) => {
      return container?.processTableData.map((data) => {
        const rowErrors = {};
        ProcessrequiredFields?.forEach((field) => {
          if (!data[field]) {
            rowErrors[field] = true;
          }
        });
        return rowErrors;
      });
    });
    setProcessTableErrors(newProcessTableErrors);

    const hasProcessTableErrors = newProcessTableErrors.some(
      (containerErrors) =>
        containerErrors.some((rowErrors) =>
          Object.values(rowErrors).some((error) => error)
        )
    );
    if (hasProcessTableErrors) {
      handleOpenModal("Fill all Process Table Data.");
      return;
    }

    // Check if at least one row exists
    const hasEmptyRow = containers.some(
      (item) => item.processTableData.length === 0
    );
    if (hasEmptyRow || containers.length === 0) {
      handleOpenModal("At least one row in the process table is required.");
      return;
    }

    try {
      // Create the editFormData with job ID and updated form data
      const editFormData = {
        formData: dataToSubmit,
        id, // Ensure this is your current job ID
      };

      // Dispatch the update action
      const result = await dispatch(editJob(editFormData));

      if (result?.payload?.success === false) {
        handleOpenModal("Update failed. Please try again.");
      } else {
        handleOpenModal("Job updated successfully!");
      }
    } catch (error) {
      console.error("Error updating job:", error);
      handleOpenModal("An error occurred. Please try again.");
    }
  };

  const handleChange = (event) => {
    const { name, value } = event.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));

    if (errors[name]) {
      setErrors((prevErrors) => ({
        ...prevErrors,
        [name]: false,
      }));
    }
  };

  const calculateTotalEstimatedCT = (containersData) => {
    const total = containersData.reduce((total, container) => {
      // Add setting time for this container (convert to number, default to 0)
      const settingTime = parseFloat(container.setting) || 0;

      const containerTotal = container.processTableData.reduce(
        (containerSum, row) => {
          // Parse the value to handle both numbers and strings
          const estimatedCT = parseFloat(row.estimatedCT) || 0;
          return containerSum + estimatedCT;
        },
        settingTime // Start with setting time for this container
      );
      return total + containerTotal;
    }, 0);

    // Return formatted to 2 decimal places
    return parseFloat(total.toFixed(2));
  };

  const handleAddRow = (containerIndex) => {
    setContainers((prevContainers) => {
      const updatedContainers = [...prevContainers];
      const containerToUpdate = { ...updatedContainers[containerIndex] };

      // Create a new row with initial data
      const newRow = {
        process: "",
        description: "",
        machineName: "",
        toolingUsed: "",
        requiredDimension: "", // Add this field here
        // startDate: new Date().toISOString().split("T")[0],
        startTime: "",
        // endDate: new Date().toISOString().split("T")[0],
        endTime: "",
        // idleCode: "",
        // startDate1: new Date().toISOString().split("T")[0],
        startTime1: "",
        // endDate1: new Date().toISOString().split("T")[0],
        endTime1: "",
        userName: "",
        // nop: 0,
      };

      // Create a new array with the updated processTableData
      const updatedProcessTableData = [
        ...containerToUpdate.processTableData,
        newRow,
      ];

      // Update the container's processTableData with the new array
      containerToUpdate.processTableData = updatedProcessTableData;

      // Update the containers state with the modified container
      updatedContainers[containerIndex] = containerToUpdate;

      return updatedContainers;
    });
  };
  const calculateCT = (updatedData) => {
    if (!updatedData.idleCode) {
      console.log(updatedData.startTime);
      const startDate = new Date(updatedData.startDate);
      const endDate = new Date(updatedData.endDate);
      const startTime = new Date(`1970-01-01T${updatedData.startTime}`);
      const endTime = new Date(`1970-01-01T${updatedData.endTime}`);
      const start =
        startDate.getTime() +
        startTime.getTime() -
        startDate.getTimezoneOffset() * 60 * 1000;
      const end =
        endDate.getTime() +
        endTime.getTime() -
        endDate.getTimezoneOffset() * 60 * 1000;
      const diff = (end - start) / (1000 * 60);

      return parseFloat(diff).toFixed(2);
      // updatedData.estimatedCT = diff;
    } else {
      const startDate = new Date(updatedData.startDate);
      const endDate = new Date(updatedData.endDate);
      const startTime = new Date(`1970-01-01T${updatedData.startTime}`);
      const endTime = new Date(`1970-01-01T${updatedData.endTime}`);
      const start =
        startDate.getTime() +
        startTime.getTime() -
        startDate.getTimezoneOffset() * 60 * 1000;
      const end =
        endDate.getTime() +
        endTime.getTime() -
        endDate.getTimezoneOffset() * 60 * 1000;
      const diff1 = (end - start) / (1000 * 60);
      const startDate1 = new Date(updatedData.startDate1);
      const endDate1 = new Date(updatedData.endDate1);
      const startTime1 = new Date(`1970-01-01T${updatedData.startTime1}`);
      const endTime1 = new Date(`1970-01-01T${updatedData.endTime1}`);
      const start1 =
        startDate1.getTime() +
        startTime1.getTime() -
        startDate1.getTimezoneOffset() * 60 * 1000;
      const end1 =
        endDate1.getTime() +
        endTime1.getTime() -
        endDate1.getTimezoneOffset() * 60 * 1000;
      const diff2 = (end1 - start1) / (1000 * 60); // difference in hours
      const diff = diff1 + diff2;
      console.log(diff);
      return parseFloat(diff).toFixed(2);
    }
  };

  const handleTextFieldChange = (
    event,
    rowIndex,
    fieldName,
    containerIndex,
    processName
  ) => {
    let value = event.target.value;
    const isBlurEvent = event.type === "blur";
    // Handle custom tool selection
    if (fieldName === "toolingUsed" && value === "custom") {
      handleOpenToolModal(containerIndex, rowIndex, processName);
      return;
    }
    setContainers((prevContainers) => {
      const updatedContainers = prevContainers.map((container, idx) => {
        if (idx === containerIndex) {
          const updatedProcessTableData = container.processTableData.map(
            (data, index) => {
              let updatedData = { ...data };
              if (index === rowIndex) {
                // Update the current field
                updatedData = { ...updatedData, [fieldName]: value };

                // Process-specific calculations
                if (processName === "Milling") {
                  if (
                    [
                      "toolingSize",
                      "dia",
                      "width",
                      "length",
                      "feed",
                      "nop",
                      "fpp",
                      "mr",
                      "dc",
                    ].includes(fieldName)
                  ) {
                    updatedData.dia = parseFloat(
                      (updatedData.toolingSize * 0.9).toFixed(2)
                    );

                    updatedData.nop = parseFloat(
                      (updatedData.width / updatedData.dia).toFixed(2)
                    );
                    updatedData.fpp = parseFloat(
                      (updatedData.length / updatedData.feed).toFixed(2)
                    );
                    updatedData.estimatedCT =
                      updatedData.nop *
                      updatedData.fpp *
                      (updatedData.mr / updatedData.dc) *
                      1.25;

                    if (fieldName === "estimatedCT") {
                      updatedData.estimatedCT = value;
                    }
                    if (
                      updatedData.estimatedCT !== undefined &&
                      !isNaN(updatedData.estimatedCT)
                    ) {
                      updatedData.estimatedHrs = updatedData.estimatedCT / 60;
                    }
                  } else if (
                    [
                      "startTime",
                      "endTime",
                      "startTime1",
                      "endTime1",
                      "idleCode",
                    ].includes(fieldName)
                  ) {
                    const diff = calculateCT(updatedData);
                    updatedData.estimatedCT = diff;
                    if (
                      updatedData.estimatedCT !== undefined &&
                      !isNaN(updatedData.estimatedCT)
                    ) {
                      updatedData.estimatedHrs = updatedData.estimatedCT / 60;
                    }
                  }
                } else if (processName === "Boring") {
                  updatedData[fieldName] = value;
                  if (
                    [
                      "mr",
                      "dc",
                      "length",
                      "width",
                      "rpm",
                      "nop",
                      "fpp",
                    ].includes(fieldName)
                  ) {
                    updatedData.nop = parseFloat(
                      (updatedData.mr / updatedData.dc).toFixed(2)
                    );
                    updatedData.fpp = parseFloat(
                      (updatedData.length / (updatedData.width * 0.1)).toFixed(
                        2
                      )
                    );
                    updatedData.estimatedCT =
                      updatedData.nop * updatedData.fpp * 1.25;

                    if (
                      updatedData.estimatedCT !== undefined &&
                      !isNaN(updatedData.estimatedCT)
                    ) {
                      updatedData.estimatedHrs = updatedData.estimatedCT / 60;
                    }
                  } else if (
                    [
                      "startTime",
                      "endTime",
                      "startTime1",
                      "endTime1",
                      "idleCode",
                    ].includes(fieldName)
                  ) {
                    const diff = calculateCT(updatedData);
                    updatedData.estimatedCT = diff;
                    if (
                      updatedData.estimatedCT !== undefined &&
                      !isNaN(updatedData.estimatedCT)
                    ) {
                      updatedData.estimatedHrs = updatedData.estimatedCT / 60;
                    }
                  }
                } else if (processName === "Drilling") {
                  updatedData[fieldName] = value;

                  // NEW DRILLING CALCULATION WITH TIME-PER-HOLE BASED ON DIAMETER
                  if (["dia", "noh"].includes(fieldName)) {
                    // Get time per hole based on diameter range
                    let timePerHole = 0;
                    const dia = parseFloat(updatedData.dia) || 0;

                    if (dia >= 1 && dia <= 14) {
                      timePerHole = 3; // 3 min/hole for diameter 3-14
                    } else if (dia >= 16 && dia <= 21) {
                      timePerHole = 8; // 8 min/hole for diameter 16-21
                    } else if (dia >= 22 && dia <= 60) {
                      timePerHole = 12; // 12 min/hole for diameter 22-42
                    }

                    // Calculate estimated CT: time per hole × number of holes
                    updatedData.estimatedCT =
                      timePerHole * (parseFloat(updatedData.noh) || 0);

                    if (
                      updatedData.estimatedCT !== undefined &&
                      !isNaN(updatedData.estimatedCT)
                    ) {
                      updatedData.estimatedHrs = updatedData.estimatedCT / 60;
                    }
                  } else if (
                    [
                      "startTime",
                      "endTime",
                      "startTime1",
                      "endTime1",
                      "idleCode",
                    ].includes(fieldName)
                  ) {
                    const diff = calculateCT(updatedData);
                    updatedData.estimatedCT = diff;
                    if (
                      updatedData.estimatedCT !== undefined &&
                      !isNaN(updatedData.estimatedCT)
                    ) {
                      updatedData.estimatedHrs = updatedData.estimatedCT / 60;
                    }
                  }
                } else if (processName === "Tapping") {
                  updatedData[fieldName] = value;

                  // NEW TAPPING CALCULATION WITH TIME-PER-HOLE BASED ON DIAMETER
                  if (["dia", "noh"].includes(fieldName)) {
                    // Get time per hole based on diameter range
                    let timePerHole = 0;
                    const dia = parseFloat(updatedData.dia) || 0;

                    if (dia >= 1 && dia <= 14) {
                      timePerHole = 2; // 2 min/hole for diameter 3-14
                    } else if (dia >= 16 && dia <= 21) {
                      timePerHole = 3; // 3 min/hole for diameter 16-21
                    } else if (dia >= 22 && dia <= 60) {
                      timePerHole = 4; // 4 min/hole for diameter 22-42
                    }

                    // Calculate estimated CT: time per hole × number of holes
                    updatedData.estimatedCT =
                      timePerHole * (parseFloat(updatedData.noh) || 0);

                    if (
                      updatedData.estimatedCT !== undefined &&
                      !isNaN(updatedData.estimatedCT)
                    ) {
                      updatedData.estimatedHrs = updatedData.estimatedCT / 60;
                    }
                  } else if (
                    [
                      "startTime",
                      "endTime",
                      "startTime1",
                      "endTime1",
                      "idleCode",
                    ].includes(fieldName)
                  ) {
                    const diff = calculateCT(updatedData);
                    updatedData.estimatedCT = diff;
                    if (
                      updatedData.estimatedCT !== undefined &&
                      !isNaN(updatedData.estimatedCT)
                    ) {
                      updatedData.estimatedHrs = updatedData.estimatedCT / 60;
                    }
                  }
                }

                // Final check for estimatedHrs calculation
                if (
                  updatedData.estimatedCT !== undefined &&
                  !isNaN(updatedData.estimatedCT)
                ) {
                  updatedData.estimatedHrs = updatedData.estimatedCT / 60;
                }
                return updatedData;
              }
              return data;
            }
          );
          return { ...container, processTableData: updatedProcessTableData };
        }
        return container;
      });

      // Trigger submission on blur if the field is "requiredDimension" or "estimatedCT"
      if (isBlurEvent) {
        const requiredFields = requiredFieldsByProcess[processName] || [];
        const currentRow =
          updatedContainers[containerIndex].processTableData[rowIndex];
        const allFieldsFilled = requiredFields.every(
          (field) =>
            currentRow[field] && currentRow[field].toString().trim() !== ""
        );
        const isLastRow =
          rowIndex ===
          updatedContainers[containerIndex].processTableData.length - 1;
        if (allFieldsFilled && isLastRow) {
          const newFormData = {
            ...formData,
            processTable: updatedContainers,
          };
          handleSubmit(null, newFormData);
        }
      }

      return updatedContainers;
    });
  };

  const handleDeleteRow = (containerIndex, rowIndex) => {
    // Clone the containers array to avoid modifying the state directly
    const updatedContainers = [...containers];

    // Clone the processTableData array for the specified container
    const updatedProcessTableData = [
      ...updatedContainers[containerIndex].processTableData,
    ];

    // Check if the processTableData array is not empty before trying to delete
    if (updatedProcessTableData.length > 0) {
      // Remove the row from the process table data for the specified container
      updatedProcessTableData.splice(rowIndex, 1);

      // Update the container with the modified processTableData array
      updatedContainers[containerIndex] = {
        ...updatedContainers[containerIndex],
        processTableData: updatedProcessTableData,
      };

      // Update the state with the modified containers array
      setContainers(updatedContainers);
    }
  };

  const addContainer = () => {
    // Create a new container with initial data
    const newContainer = {
      processName: "",
      processTableData: [],
    };

    // Update the containers state with the new container
    setContainers((prevContainers) => [...prevContainers, newContainer]);

    // Update the formData state to include the new containers
    setFormData((prevData) => ({
      ...prevData,
      processTable: [...prevData.processTable, newContainer],
    }));
  };

  const deleteContainer = (containerIndex) => {
    // Clone the containers array to avoid modifying the state directly
    const updatedContainers = [...containers];

    // Remove the container at the specified containerIndex
    updatedContainers.splice(containerIndex, 1);

    // Update the state with the modified containers array
    setContainers(updatedContainers);

    // Update the formData state to remove the deleted container
    setFormData((prevData) => ({
      ...prevData,
      processTable: prevData.processTable.filter(
        (_, index) => index !== containerIndex
      ),
    }));
  };
  const formatTotalEstimatedCTWithBreakdown = (containersData) => {
    let processTime = 0;
    let settingTime = 0;

    containersData.forEach((container) => {
      settingTime += parseFloat(container.setting) || 0;
      container.processTableData.forEach((row) => {
        processTime += parseFloat(row.estimatedCT) || 0;
      });
    });

    const total = processTime + settingTime;

    return {
      total: formatDecimalMinutesToMinutesSeconds(total),
      processTime: formatDecimalMinutesToMinutesSeconds(processTime),
      settingTime: formatDecimalMinutesToMinutesSeconds(settingTime),
      rawTotal: total,
    };
  };

  // Usage in your component:
  const totalCTBreakdown = formatTotalEstimatedCTWithBreakdown(containers);
  const handleDropdownChange = (e, containerIndex, fieldName) => {
    const updatedContainers = JSON.parse(JSON.stringify(containers));

    updatedContainers.forEach((item, index) => {
      if (index === containerIndex) {
        item[fieldName] = e.target.value;
      }
    });

    setContainers(updatedContainers);
  };

  return (
    <Dashboard>
      <>
        <Box display={"flex"}>
          <ArrowBack />
          <h2>Update Job</h2>
        </Box>
        <TableContainer component={Paper}>
          <Table sx={{ minWidth: 650 }} aria-label="spanning table">
            <TableBody>
              <TableRow>
                <TableCell align="center">SO/Wo No</TableCell>
                <TableCell align="center">
                  <TextField
                    label="So/Wo No"
                    id="outlined-size-small"
                    size="small"
                    variant="outlined"
                    name="soWo"
                    value={formData?.soWo}
                    onChange={handleChange}
                    error={errors.soWo} // Set error prop based on the error state
                    helperText={errors.soWo ? "This field is required" : ""}
                    InputLabelProps={{
                      shrink: true,
                    }}
                  />
                </TableCell>
                <TableCell align="center">Prod.Order No</TableCell>
                <TableCell align="center">
                  <TextField
                    label="Prod.Order No"
                    id="outlined-size-small"
                    size="small"
                    name="prodOrderNo"
                    value={formData?.prodOrderNo}
                    onChange={handleChange}
                    error={errors.prodOrderNo}
                    helperText={
                      errors.prodOrderNo ? "This field is required" : ""
                    }
                    InputLabelProps={{
                      shrink: true,
                    }}
                  />
                </TableCell>
                {/* <TableCell align="center">WO Date</TableCell>
                <TableCell align="center">
                  <TextField
                    id="date"
                    label="WO Date"
                    type="date"
                    size="small"
                    variant="outlined"
                    InputLabelProps={{
                      shrink: true,
                    }}
                    //   value={selectedDate.toISOString().split("T")[0]}
                    //   onChange={(e) => handleDateChange(new Date(e.target.value))}
                    name="woDate"
                    value={formattedEditDate(formData?.woDate)}
                    onChange={handleChange}
                  />
                </TableCell> */}
                <TableCell align="center">PO No</TableCell>
                <TableCell align="center">
                  <TextField
                    label="PO No"
                    id="outlined-size-small"
                    size="small"
                    name="poNo"
                    value={formData?.poNo}
                    onChange={handleChange}
                    error={errors.poNo}
                    helperText={errors.poNo ? "This field is required" : ""}
                    InputLabelProps={{
                      shrink: true,
                    }}
                  />
                </TableCell>
              </TableRow>
              <TableRow>
                <TableCell align="center">Job Name</TableCell>
                <TableCell align="center">
                  <TextField
                    label="Job Name"
                    id="outlined-size-small"
                    size="small"
                    name="jobName"
                    value={formData?.jobName}
                    onChange={handleChange}
                    error={errors.jobName}
                    helperText={errors.jobName ? "This field is required" : ""}
                    InputLabelProps={{
                      shrink: true,
                    }}
                  />
                </TableCell>
                <TableCell align="center">Drawing No</TableCell>
                <TableCell align="center">
                  <TextField
                    label="Drawing No"
                    id="outlined-size-small"
                    size="small"
                    name="dragNo"
                    value={formData?.dragNo}
                    onChange={handleChange}
                    error={errors.dragNo}
                    helperText={errors.dragNo ? "This field is required" : ""}
                    InputLabelProps={{
                      shrink: true,
                    }}
                  />
                </TableCell>
                <TableCell align="center">Total Estimated CT</TableCell>
                <TableCell align="center">
                  <TextField
                    label="Estimated CT"
                    id="outlined-size-small"
                    size="small"
                    name="estimatedtotalCT"
                    value={formatTotalEstimatedCT(formData.estimatedtotalCT)}
                    disabled
                    onChange={handleChange}
                    error={errors.estimatedtotalCT}
                    helperText={
                      errors.estimatedtotalCT ? "This field is required" : ""
                    }
                    InputLabelProps={{
                      shrink: true,
                    }}
                  />
                  {/* Optional: Show breakdown tooltip */}
                  <Tooltip
                    title={`Process Time: ${totalCTBreakdown.processTime} | Setting Time: ${totalCTBreakdown.settingTime}`}
                    arrow
                  >
                    <Typography
                      variant="caption"
                      display="block"
                      sx={{ mt: 0.5, color: "text.secondary" }}
                    >
                      (Includes setting time)
                    </Typography>
                  </Tooltip>
                </TableCell>
              </TableRow>
              <TableRow></TableRow>
            </TableBody>
          </Table>
        </TableContainer>
        {containers?.map((container, containerIndex) => (
          <TableContainer
            key={containerIndex}
            component={Paper}
            sx={{ marginTop: 3 }}
          >
            <TableRow sx={{ display: "flex", justifyContent: "space-between" }}>
              <div>
                <TableCell>{containerIndex + 1}</TableCell>
                <TableCell>
                  <FormControl>
                    <InputLabel
                      id="demo-multiple-name-label"
                      style={{ color: "#1D5393" }}
                    >
                      MainProcessName
                    </InputLabel>
                    <Select
                      value={container.processName}
                      label="processName"
                      className="input"
                      size="large"
                      onChange={(e) =>
                        handleDropdownChange(e, containerIndex, "processName")
                      }
                    >
                      <MenuItem value="Milling">MILLING</MenuItem>
                      <MenuItem value="Boring">BORING</MenuItem>
                      <MenuItem value="Drilling">DRILLING</MenuItem>
                      <MenuItem value="Tapping">TAPPING</MenuItem>
                    </Select>
                  </FormControl>
                </TableCell>
                <TableCell align="center">
                  Setting for All Process Admin have to add setting Time in
                  minutes
                </TableCell>
                <TableCell align="center">
                  <TextField
                    label="settingTime"
                    className="input"
                    size="small"
                    name={`setting-${containerIndex}`}
                    value={container.setting}
                    onChange={(e) =>
                      handleDropdownChange(e, containerIndex, "setting")
                    }
                    InputLabelProps={{
                      shrink: true, // This ensures the label shrinks when there's a value
                    }}
                  />
                </TableCell>
              </div>
              <Tooltip title="Delete Container" arrow placement="top">
                <IconButton size="small" sx={{ marginRight: 3 }}>
                  <DeleteOutlineIcon
                    color="error"
                    onClick={() => deleteContainer(containerIndex)}
                  />
                </IconButton>
              </Tooltip>
            </TableRow>
            {/* Add ProcessTable component with appropriate props */}
            <ProcessTable
              key={containerIndex}
              data={container.processTableData}
              handleTextFieldChange={handleTextFieldChange}
              handleDeleteRow={handleDeleteRow}
              processTableErrors={processTableErrors}
              containerIndex={containerIndex}
              handleAddRow={handleAddRow}
              selectedProcessName={container.processName}
              handleValidation={handleValidation}
              ToolSelect={ToolSelect} // Add this prop
              handleOpenToolModal={handleOpenToolModal} // Add this prop
            />
          </TableContainer>
        ))}

        <Box display={"flex"} marginTop={5}>
          <div>
            <Button
              onClick={addContainer}
              color="primary"
              sx={{
                backgroundColor: "#1d5393",
                color: "#fff",
                margin: 2,
                "&:hover": {
                  backgroundColor: "#245BA1", // Adjust the color for hover effect
                },
                "&:active": {
                  backgroundColor: "#1d5393", // Keep the same color as the initial state
                },
              }}
            >
              Add Main Process
            </Button>
            <Button
              color="primary"
              sx={{
                backgroundColor: "#1d5393",
                color: "#fff",
                marginRight: "10px",
                "&:hover": {
                  backgroundColor: "#245BA1", // Adjust the color for hover effect
                },
                "&:active": {
                  backgroundColor: "#1d5393", // Keep the same color as the initial state
                },
              }}
              onClick={handleSubmit}
            >
              Update
            </Button>
          </div>
          {/* Common Custom Tool Modal */}
          <CustomToolModal
            open={toolModalOpen}
            onClose={handleCloseToolModal}
            onSave={handleSaveCustomTool}
            title="Add Custom Tool"
            inputLabel="Tool Name"
            buttonText="Save Tool"
          />
          <MyModal
            open={isModalOpen} // Use 'open' instead of 'isOpen'
            onClose={handleCloseModal}
            title="Error Message" // Set the title you want to display
            description={modalMessage} // Use 'description' instead of 'message'
            buttonText="OK" // Set the button text you want to display
            onButtonClick={handleCloseModal} // Set the button click handler
          />
          <MyModal
            open={isModalOpen}
            onClose={handleCloseModal}
            title={modalMessage.includes("success") ? "Success" : "Error"}
            description={modalMessage}
            buttonText="OK"
            onButtonClick={handleCloseModal}
          />
        </Box>
      </>
    </Dashboard>
  );
}

export default UpdateJob;
